<template>
  <div class="thumbnails">
    <div class="thumbnail">
      <div v-on:click="switchMap('ortofoto')" class="clickable">
        <img src="@/assets/ortofoto.png" />
      </div>
      <div>Ortofoto</div>
    </div>
    <div class="thumbnail">
      <div v-on:click="switchMap('basic')" class="clickable">
        <img src="@/assets/basic.png" />
      </div>
      <div>Základní</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Basemaps",
  mounted() {
    this.$emit("caption", "Mapy");
  },
  methods: {
    switchMap: function(map) {
      this.$root.$refs.webMap.changeBaseMap(map);
    }
  }
};
</script>

<style scoped>
.thumbnails {
  display: flex;
  justify-content: center;
}

img {
  width: 100%;
  padding: 0px;
  margin: 0px;
}

.clickable {
  cursor: pointer;
  -webkit-box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.75);
  padding-top: 3px;
  margin: 5px;
}
.thumbnail {
  width: 85px;
  font-size: 12px;
  text-align: center;
}
</style>
